import { Map } from 'immutable';
import actions from './action';


const initState = new Map({ 
  success: false,
  msg: '',
  result: [],
  listresult: [],
  listsuccess: false,
  total_count: 0,
  page: 1,
});


export default function logReducer(state = initState, action) {
   switch (action.type) {
    case actions.LOG_LIST_READ_SUCCESS:
      return state
        .set('success', action.success)
        .set('msg', action.msg)
        .set('data', action.data)
        .set('totalCount', action.totalCount)
        .set('page',action.page);
    default:
      return state;
  }
}

